import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "reactstrap";
import Grids from "./Grid/Grids";
import CheckMark from "../images/checkmark.png";
import Marquee from "react-fast-marquee";
const EBMImages = (props) => {
  let machine_card_details = props.machine_card_details;
  let imageUrls = props.imageUrls;

  const [marqueeContent, setMarqueeContent] = useState("");

  const removeUnderscores = (inputString) => {
    const underscorePattern = /_/g;
    const resultString = inputString.replace(underscorePattern, " ");
    return resultString;
  };

  const uniqueGrids = new Set();

  machine_card_details.Parts_Keys.forEach((eachParts) => {
    const grids = machine_card_details.Parts[eachParts].grids;
    grids.forEach((grid) => {
      const gridText = `Grid ${grid.row * 6 + grid.column + 1}: ${grid.count} `;
      uniqueGrids.add(gridText);
    });
  });
  useEffect(() => {
    const joinTag = Array.from(uniqueGrids).join("  ");
    setMarqueeContent(joinTag);
  }, [uniqueGrids]); 
 
  return (
    <Container>
      {machine_card_details.Parts_Keys?.length !== 0 && (
        <Row>
          {machine_card_details.Parts_Keys?.map((eachParts, eachPartIndex) => (
            <Col
              key={eachParts}
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={3}
              xxl={3}
              className="my-3 justify-content-center align-items-center"
            >
              <>
                <Row className="text-center justify-content-center">
                  {renderPartImage(eachParts, imageUrls[eachParts])}
                </Row>
                <Row className="text-center justify-content-center mt-2">
                  {machine_card_details.Parts[eachParts].defect_count === 0 ? (
                    <Col>
                      <div className="align_value">
                        <>{removeUnderscores(eachParts)} :&nbsp;</>

                        {machine_card_details.Parts[eachParts].status !==
                        true ? (
                          <img
                            src={CheckMark}
                            alt="checkmark"
                            className="check_tickmark"
                          />
                        ) : (
                          <></>
                        )}
                        <br />
                      </div>
                    </Col>
                  ) : (
                    <Col>
                      <div className="align_value">
                        <strong className="align_value">
                          {removeUnderscores(eachParts)} :&nbsp;{" "}
                        </strong>
                        <strong className="defect-countColor">
                          {machine_card_details.Parts[eachParts].defect_count}
                        </strong>
                        {machine_card_details.Parts[eachParts].grids.length <=
                        2 ? (
                          <>
                            {" "}
                            <br />
                            {machine_card_details.Parts[eachParts].grids.map(
                              (grid, index) => (
                                <span key={index}>
                                  <strong>
                                    Grid{" "}
                                    {machine_card_details.Parts[eachParts]
                                      .grids[index].row *
                                      6 +
                                      machine_card_details.Parts[eachParts]
                                        .grids[index].column +
                                      1}
                                    : {grid.count}
                                    &nbsp; &nbsp;
                                  </strong>
                                </span>
                              )
                            )}
                          </>
                        ) : (
                          <>
                            {" "}
                            <Marquee speed={60} gradient={false} pauseOnHover>
                              <strong>{marqueeContent}</strong>
                            </Marquee>
                          </>
                        )}
                      </div>
                    </Col>
                  )}
                </Row>
              </>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );

  function renderPartImage(eachParts, imageUrl) {
    const partDetails = machine_card_details?.Parts[eachParts];
    const isStatusTrue = partDetails?.status === true;

    return (
      <Col
        key={eachParts}
        className={`part_image ${isStatusTrue ? "" : "checkmark-image"} ${
          isStatusTrue ? "" : "blurred-image"
        }`}
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        xxl={12}
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      >
        {isStatusTrue ? (
          <>
            <Grids highlightedCells={partDetails.grids} />
          </>
        ) : (
          <></>
        )}
      </Col>
    );
  }
};

export default EBMImages;
